import * as React from "react";
import styles from "./CheckedMark.module.scss";
import check from "../../images/check.png";

interface Props {
  id: string;
}

const CheckedMark = (props: Props): JSX.Element => (
  <div className={styles.checkedMark} id={props.id}>
    <img src={check} alt="Checked Mark" />
  </div>
);
export default CheckedMark;
